const patientassist = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Patient Assist',
            },
            {
                "type": "tabs",
                "size": "12",
                "style": "",
                "class": "px-4 pt-4",
                "children": [
                    {
                        "title": "Conversations",
                        "service": "pages",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": true,
                            "activeToggle": true,
                            "deleteButton": true, 
                            "addNewSuccessTitle": 'Topic Added!',
                            "addNewSuccessMessage": 'Topic Added Successfully!',
                            "addNewErrorTitle": 'Topic Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Topic Deleted!',
                            "deleteSuccessMessage": 'Topic Deleted Successfully!',
                            "deleteErrorTitle": 'Topic Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Topic Activated!',
                            "activeSuccessMessage": 'Topic Activated Successfully!',
                            "activeErrorTitle": 'Topic Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Topic Updated!',
                            "updateSuccessMessage": 'Topic Updated Successfully!',
                            "updateErrorTitle": 'Topic Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Conversations",
                                "type": "page",
                                "variant": "add",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "form": {
                                    "title": {
                                    "type": 'text',
                                    "label": 'Conversation Name',
                                    "placeholder": 'Enter Conversation Name',
                                    "required": true,
                                    "info": true,
                                    "character_count": 250,
                                    "disabled": false,
                                    "class": '',
                                    "size": "12",
                                    "style": ""
                                    },
                                },
                                "additionalProps": {
                                    // "address": '',
                                    // "regular_hours": [{"id":1,"title":"Monday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":2,"title":"Tuesday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":3,"title":"Wednesday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":4,"title":"Thursday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":5,"title":"Friday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":6,"title":"Saturday","status":[{"name":"Closed","value":true},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":7,"title":"Sunday","status":[{"name":"Closed","value":true},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"}]
                                }
                            },
                        },
                        "children": [
                            {
                                "type": "patientAssistTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Select a Conversation",
                                    "type": "list",
                                    "info": true,
                                    "size": "4",
                                    "style": "",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "title": "Tab Two",
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Conversation Name',
                                            "placeholder": 'Enter Conversation Name',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "address": {
                                            "type": 'patientAssistChat',
                                            "label": 'Address',
                                            "placeholder": 'Enter Address',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        "title": "Settings",
                        "service": "category",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "descriptionTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "text": {
                                        "type": 'ckeditor',
                                        "label": 'Description',
                                        "placeholder": 'Enter Description',
                                        "required": false,
                                        "info": true,
                                        "character_count": 1000,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            },                            
                        ]
                    },
                ]
            }
        ]
    }
]

export { patientassist };